import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-16595b42")

_pushScopeId("data-v-16595b42")
const _hoisted_1 = {
  class: "vista-Detalle container-fluid",
  style: {"background-color":"#f4f4f4","margin-top":"-0.2rem"}
}
const _hoisted_2 = { class: "row col-md-12" }
const _hoisted_3 = { class: "col-md-9" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_TarjetaDetalle = _resolveComponent("TarjetaDetalle")
  const _component_SeccionComentarios = _resolveComponent("SeccionComentarios")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("div", _hoisted_3, [
        (_ctx.DatosRequisicionDetalle)
          ? (_openBlock(), _createBlock(_component_TarjetaDetalle, {
              key: 0,
              class: "tarjetaDetalle mt-3",
              requisicionPagoId: _ctx.DatosRequisicionDetalle.requisicionPagoId,
              razonSocial: _ctx.DatosRequisicionDetalle.razonSocial,
              tipoPagoId: _ctx.DatosRequisicionDetalle.tipoPagoId,
              tipoPago: _ctx.DatosRequisicionDetalle.tipoPago,
              fechaSolicitud: _ctx.DatosRequisicionDetalle.fechaSolicitud,
              fechaPropuesta: _ctx.DatosRequisicionDetalle.fechaProgramadaPago,
              nombreBeneficiario: _ctx.DatosRequisicionDetalle.nombreBeneficiario,
              importe: _ctx.DatosRequisicionDetalle.importe,
              medioInstruccion: _ctx.DatosRequisicionDetalle.formaPago,
              numeroFactura: _ctx.DatosRequisicionDetalle.numeroFactura,
              uuid: _ctx.DatosRequisicionDetalle.uuid,
              observacionInstruccion: _ctx.DatosRequisicionDetalle.observacionPago,
              conceptoPagoId: _ctx.DatosRequisicionDetalle.conceptoPagoId,
              conceptoPagos: _ctx.DatosRequisicionDetalle.conceptoPagos,
              nombreTipoGasto: _ctx.DatosRequisicionDetalle.tipoGasto.nombreGasto,
              nombreRubro: _ctx.DatosRequisicionDetalle.tipoRubro.nombreRubro,
              cuentaBeneficiario: _ctx.DatosRequisicionDetalle.cuentaBeneficiario,
              bancoBeneficiario: _ctx.DatosRequisicionDetalle.bancoBeneficiario,
              clabe: _ctx.DatosRequisicionDetalle.cuentaCLABE,
              referencia: _ctx.DatosRequisicionDetalle.referencia,
              divisa: _ctx.DatosRequisicionDetalle.divisaId,
              rfcBeneficiario: _ctx.DatosRequisicionDetalle.rfcBeneficiario,
              convenioServicioPago: _ctx.DatosRequisicionDetalle.convenioServicioPago,
              usuarioAutorizadorId: _ctx.DatosRequisicionDetalle.usuarioAutorizadorId,
              usuarioSolicitadorId: _ctx.DatosRequisicionDetalle.usuarioSolicitadorId,
              usuarioAutorizador: _ctx.DatosRequisicionDetalle.usuarioAutorizador,
              usuarioSolicitante: _ctx.DatosRequisicionDetalle.usuarioSolicitante,
              estatusRequisicionId: _ctx.DatosRequisicionDetalle.estatusRequisicionId,
              rolUsuario: _ctx.rolUsuario,
              correoSolicitante: _ctx.DatosRequisicionDetalle.correoSolicitante,
              correoAutorizador: _ctx.DatosRequisicionDetalle.correoAutorizador,
              documentos: _ctx.DatosRequisicionDetalle.documentos,
              centroCostos: _ctx.DatosRequisicionDetalle.centroCostos,
              unidadNegocio: _ctx.DatosRequisicionDetalle.unidadNegocio,
              tieneVerificador: _ctx.tieneVerificador,
              tieneMesaControl: _ctx.tieneMesaControl,
              tipoRequisicion: String(_ctx.DatosRequisicionDetalle.tipoRequisicion),
              claveCodigo: _ctx.DatosRequisicionDetalle.claveCodigo
            }, null, 8, ["requisicionPagoId", "razonSocial", "tipoPagoId", "tipoPago", "fechaSolicitud", "fechaPropuesta", "nombreBeneficiario", "importe", "medioInstruccion", "numeroFactura", "uuid", "observacionInstruccion", "conceptoPagoId", "conceptoPagos", "nombreTipoGasto", "nombreRubro", "cuentaBeneficiario", "bancoBeneficiario", "clabe", "referencia", "divisa", "rfcBeneficiario", "convenioServicioPago", "usuarioAutorizadorId", "usuarioSolicitadorId", "usuarioAutorizador", "usuarioSolicitante", "estatusRequisicionId", "rolUsuario", "correoSolicitante", "correoAutorizador", "documentos", "centroCostos", "unidadNegocio", "tieneVerificador", "tieneMesaControl", "tipoRequisicion", "claveCodigo"]))
          : _createCommentVNode("", true)
      ]),
      _createVNode(_component_SeccionComentarios, {
        rolUsuario: _ctx.rolUsuario,
        estatusRequisicionId: _ctx.DatosRequisicionDetalle.estatusRequisicionId,
        requsicionId: _ctx.DatosRequisicionDetalle.requisicionPagoId,
        tieneVerificador: _ctx.tieneVerificador,
        class: "mt-3"
      }, null, 8, ["rolUsuario", "estatusRequisicionId", "requsicionId", "tieneVerificador"])
    ])
  ]))
})